import { Component, EventEmitter, Output } from '@angular/core'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { PlayerHttp } from '@core/https'

@Component({
  selector: 'app-chips-request-v1',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './chips-request.component.html',
  styleUrl: './chips-request.component.sass',
})
export class ChipsRequestComponent {
  @Output() onSuccess = new EventEmitter()

  form = this._formBuilder.group({
    chips: [0, [Validators.required, Validators.min(1)]],
  })

  constructor(
    private _formBuilder: FormBuilder,
    private _playerHttp: PlayerHttp,
  ) {}

  sendRequest() {
    if (this.form.valid) {
      this._playerHttp.submitChipsRequest(this.form.get('chips')?.value || 0).subscribe((i) => {
        this.onSuccess.emit()
      })
    }
  }
}
